import { emptySplitApi as api } from "../../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiPortalV1EmployeeEmployeesCreate: build.mutation<
      ApiPortalV1EmployeeEmployeesCreateApiResponse,
      ApiPortalV1EmployeeEmployeesCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/employee/employees/`,
        method: "POST",
        body: queryArg.createEmployee,
      }),
    }),
    apiPortalV1EmployeeEmployeesRetrieve: build.query<
      ApiPortalV1EmployeeEmployeesRetrieveApiResponse,
      ApiPortalV1EmployeeEmployeesRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/employee/employees/${queryArg.id}/`,
      }),
    }),
    apiPortalV1EmployeeEmployeesPartialUpdate: build.mutation<
      ApiPortalV1EmployeeEmployeesPartialUpdateApiResponse,
      ApiPortalV1EmployeeEmployeesPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/employee/employees/${queryArg.id}/`,
        method: "PATCH",
        body: queryArg.patchedPatchEmployee,
      }),
    }),
    apiPortalV1EmployeeEmployeesToggleStatusCreate: build.mutation<
      ApiPortalV1EmployeeEmployeesToggleStatusCreateApiResponse,
      ApiPortalV1EmployeeEmployeesToggleStatusCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/employee/employees/${queryArg.id}/toggle-status/`,
        method: "POST",
        body: queryArg.toggleEmployeeStatus,
      }),
    }),
    apiPortalV1EmployeeEmployeesDemographicFieldsRetrieve: build.query<
      ApiPortalV1EmployeeEmployeesDemographicFieldsRetrieveApiResponse,
      ApiPortalV1EmployeeEmployeesDemographicFieldsRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/employee/employees/demographic-fields/`,
        params: {
          organization_id: queryArg.organizationId,
        },
      }),
    }),
    apiPortalV1EmployeeEmployeesOrganizationEmployeesRetrieve: build.query<
      ApiPortalV1EmployeeEmployeesOrganizationEmployeesRetrieveApiResponse,
      ApiPortalV1EmployeeEmployeesOrganizationEmployeesRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/employee/employees/organization-employees/`,
        params: {
          account_id: queryArg.accountId,
          organization_id: queryArg.organizationId,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as portalApi };
export type ApiPortalV1EmployeeEmployeesCreateApiResponse =
  /** status 201  */ object;
export type ApiPortalV1EmployeeEmployeesCreateApiArg = {
  /** Employee ID */
  id: number;
  createEmployee: CreateEmployee;
};
export type ApiPortalV1EmployeeEmployeesRetrieveApiResponse =
  /** status 200  */ object;
export type ApiPortalV1EmployeeEmployeesRetrieveApiArg = {
  /** Employee ID */
  id: number;
  /** Employee ID */
  pk: number;
};
export type ApiPortalV1EmployeeEmployeesPartialUpdateApiResponse =
  /** status 200  */ object;
export type ApiPortalV1EmployeeEmployeesPartialUpdateApiArg = {
  /** Employee ID */
  id: number;
  /** Employee ID */
  pk: number;
  patchedPatchEmployee: PatchedPatchEmployee;
};
export type ApiPortalV1EmployeeEmployeesToggleStatusCreateApiResponse =
  /** status 200  */ object;
export type ApiPortalV1EmployeeEmployeesToggleStatusCreateApiArg = {
  /** Employee ID */
  id: number;
  /** Employee ID */
  pk: number;
  toggleEmployeeStatus?: ToggleEmployeeStatus;
};
export type ApiPortalV1EmployeeEmployeesDemographicFieldsRetrieveApiResponse =
  /** status 200  */ any;
export type ApiPortalV1EmployeeEmployeesDemographicFieldsRetrieveApiArg = {
  /** Employee ID */
  id: number;
  /** ID of the organization */
  organizationId: number;
};
export type ApiPortalV1EmployeeEmployeesOrganizationEmployeesRetrieveApiResponse =
  /** status 200  */ any;
export type ApiPortalV1EmployeeEmployeesOrganizationEmployeesRetrieveApiArg = {
  /** ID of the account (optional). If provided, returns only the employee associated with this account. */
  accountId?: number;
  /** Employee ID */
  id: number;
  /** ID of the organization */
  organizationId: number;
};
export type CreateEmployee = {
  organization_id: number;
  first_name: string;
  last_name: string;
  email: string;
  account_type: number;
  survey_status: number;
  team_external_id?: string | null;
  manager_id?: number | null;
};
export type PatchedPatchEmployee = {
  first_name?: string;
  last_name?: string;
  account_type?: number;
  status?: number;
  survey_status?: number;
  team_external_id?: string | null;
  departure_date?: string | null;
  departure_reason?:
    | "resignation"
    | "retirement"
    | "termination"
    | "layoff"
    | "end_of_term"
    | "transfer"
    | "volunteer_end"
    | "death"
    | "other"
    | "unknown"
    | null;
  demographic_data?: {
    [key: string]: any;
  };
  employee_record_data?: {
    [key: string]: any;
  };
  email?: string;
  manager_id?: number | null;
};
export type ToggleEmployeeStatus = {
  departure_date?: string | null;
  departure_reason?:
    | "resignation"
    | "retirement"
    | "termination"
    | "layoff"
    | "end_of_term"
    | "transfer"
    | "volunteer_end"
    | "death"
    | "other"
    | "unknown"
    | null;
};
export const {
  useApiPortalV1EmployeeEmployeesCreateMutation,
  useApiPortalV1EmployeeEmployeesRetrieveQuery,
  useApiPortalV1EmployeeEmployeesPartialUpdateMutation,
  useApiPortalV1EmployeeEmployeesToggleStatusCreateMutation,
  useApiPortalV1EmployeeEmployeesDemographicFieldsRetrieveQuery,
  useApiPortalV1EmployeeEmployeesOrganizationEmployeesRetrieveQuery,
} = injectedRtkApi;
